import { configureStore } from "@reduxjs/toolkit";
import myFleetReducer from "./myFleet/myFleet.slice";
import portcodesReducer from "./portCodes/portCodes.slice";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import userInfoReducer from "./userInfo/userInfo.slice";
import reportsReducer from "./reports/reports.slice";
import seempReducer from "./seemp/seemp.slice";
import adminReducer from "./admin/admin.slice";

const client = new ApolloClient({
	uri: "https://abs-erp.api.prudentconsulting.in/api",
	cache: new InMemoryCache(),
});

export const store = configureStore({
	reducer: {
		myFleet: myFleetReducer,
		portCodes: portcodesReducer,
		userInfo: userInfoReducer,
		reports: reportsReducer,
		seemp: seempReducer,
		admin: adminReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			thunk: {
				extraArgument: { client }, // Pass Apollo Client instance as extra argument
			},
		}),
});
